<template>
<div class="background-03">

  <v-layout row wrap>
    <v-flex xs12 sm2 md2 class="hidden-xs-only ">
      <image-app class="animated fadeInLeft" :imaSize="300" imaSrc="design/banco1-1-3" imaAlt=""></image-app>
    </v-flex>
    <v-flex xs12 sm9 class="animated fadeInUp dura_1">
      <ui-title-one titleAccess="Presupuesto mensual " titleLevel="h1">
        <template slot="partOne"> Presupuesto <br></template>
        <!-- <template slot="partTwo"></template> -->
        <template slot="partThree"> mensual </template>
      </ui-title-one>
    </v-flex>
  </v-layout>

  <v-layout row wrap>
    <v-flex xs12 class="text-xs-center">
      <ui-simple-lsc  :vidTittle="'Presupuesto mensual'" videoEmbed="ADMINISTRACIONDINERO35PresupuestoMensual.mp4"></ui-simple-lsc>
    </v-flex>
    <v-flex xs12 md6 class="animated fadeInUp dura_2 aligner">
      <p class="text-box adorn-bottom">Para realizar el <strong>presupuesto</strong> se necesita discriminar los
        <tooltip class="tip font-red" texto="ingresos" tooltip="Cantidad de dinero que recibe una persona natural o jurídica por la venta de sus productos o servicios." textPos="text-top"></tooltip> y
        <tooltip class="tip font-red" texto="gastos" tooltip="Es la cantidad de dinero que debe hacerse cuando se adquiere un producto o servicio." textPos="text-top"></tooltip> como lo muestran las tablas anteriores. <br><br> Una vez realizado el presupuesto, es importante hacer un seguimiento de los <strong>gastos</strong> en relación con los <strong>ingresos</strong>, así establecerá un plan para mejorar
        las finanzas personales, optimizando la
        <strong>administración</strong> del dinero.
      </p>
    </v-flex>
    <v-flex xs12 sm5 md6 mb-5 text-xs-center class="aligner animated fadeIn dura_2">
      <image-app class="animated fadeInLeft" :imaSize="480" imaSrc="contenido/diapositiva_36" imaAlt="Gráfica de un presupuesto por años"></image-app>
    </v-flex>
  </v-layout>

</div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>
<style lang="scss" scoped>
.tip {
    display: inline-block;
    text-decoration: underline !important;
}

.tooltip-elem {
    text-decoration: underline !important;
    .tooltiptext-elem {
        width: 377px !important;
    }
}
</style>



// WEBPACK FOOTER //
// davivienda-35.vue?0fd8c070